import React from 'react';
import Icon from '../Icon';
import clsx from 'clsx';
import { translate } from '../../Services/translation';
import { ItemStatus, ItemStatusEnum } from '../../Types/ItemStatus';

interface DiscontinuedItemProps {
  className?: string;
  itemStatus: ItemStatus;
}

const DiscontinuedItem: React.FC<DiscontinuedItemProps> = ({
  className,
  itemStatus,
}) => {
  if (itemStatus != ItemStatusEnum.ToBeDiscontinued) {
    return null;
  }

  return (
    <div
      className={clsx(
        className,
        'mb-4 flex w-full items-center rounded border border-warning-500 bg-warning-100 p-2 pl-3'
      )}
    >
      <Icon
        name="info-circle"
        className="mr-1.5 h-5 w-5 stroke-gray-700"
      />
      <div className="line-h self-center text-md/5 font-light text-gray-700">
        {translate('item-status.discontinued')}
      </div>
    </div>
  );
};

export default DiscontinuedItem;
